import {gql} from 'graphql-request';

const GET_PRODUCT_LIST_PRODUCTS_BY_SLUG_QUERY = gql`
  query getProductListProducts(
    $after: String
    $slug: String
    $sort: ProductsQuerySortParameter
    $filter: ProductFilterParameter
    $facets: [String]
    $includeAward: Boolean!
  ) {
    productList(
      after: $after
      slug: $slug
      sort: $sort
      filter: $filter
      facets: $facets
    ) {
      products {
        id
        award @include(if: $includeAward)
        brand
        sku
        name
        url
        reviews {
          avgRating
          totalCount
        }
        variants {
          id
          color
          upc
          mediaGallery {
            url
          }
          offer {
            id
            price
          }
          selectedOptions {
            label
            key
            value
          }
          sku
        }
        priceRange {
          min
          max
        }
        options {
          key
          label
          values {
            label
            value
            swatch {
              type
              value
            }
          }
        }
        mostSpecificCategory {
          name
          url
          breadcrumbs {
            name
          }
        }
      }
      pageCursors {
        around {
          isCurrent
          page
          cursor
        }
      }
      totalCount
    }
  }
`;

export default GET_PRODUCT_LIST_PRODUCTS_BY_SLUG_QUERY;
